"use strict";

import tocbot from 'tocbot';

/**
 * Implements the table of contents.
 */
export default class TableOfContents {
	constructor() {
		const content = document.querySelector( '.entry-content' );
		var sideBar = document.querySelector( '.right-sidebar__table-of-contents' );
		if ( ! content || ! content.children.length || ! sideBar ) {
			return;
		}

		this.makeIDs( content );
		this.markHeadingsToIgnore();

		var clickedLink = false;

		tocbot.init({
			tocSelector: '.js-toc',
			contentSelector: '.entry-content',
			headingSelector: 'h1, h2, h3, h4, h5, h6, .iportal-collapsed__title',
			hasInnerContainers: false,
			ignoreSelector: '.js-toc-ignore',
			collapseDepth: 2,
			orderedList: false,
			headingsOffset: 64 + 32, // Admin+Nav-Bar
			headingObjectCallback: this.getHeadingObjectCallback(),
			onClick: () => { clickedLink = true; },
			scrollEndCallback: () => {
				if ( clickedLink ) {
					document.body.dispatchEvent(
						new Event( 'iportal-core:toc-scroll-end' )
					);
					clickedLink = false;
				}
			},
		});

		this.toc = document.getElementById( 'table-of-contents' );

		const appendix = document.getElementById( 'appendix-popup-content' );
		if ( appendix ) {
			const appendixLink = document.createElement( 'a' );
			appendixLink.textContent = appendix.textContent;
			appendixLink.href = "#appendix-popup-content";
			appendixLink.setAttribute( 'class', 'd-none d-print-block' );
			this.toc.querySelector( '.card-body' ).insertBefore( appendixLink, null );
		}

		if ( this.toc.querySelectorAll( ':scope .toc-list' ).length === 0 ) {
			return;
		}
		this.oldParent = null;
		this.oldNextSibling = null;
		window.addEventListener( 'beforeprint', () => { this.fixPosition( true ); } );
		window.addEventListener( 'afterprint', () => { this.fixPosition( false ); } );
		this.fixPosition( window.matchMedia( 'print' ).matches );
	}

	/**
	 * Get callback for tocbot's headingObjectCallback option.
	 *
	 * Modifies the header object so that collapsed boxes get indented.
	 */
	getHeadingObjectCallback() {
		var lastObj = null;
		var lastElem = null;

		return (obj, elem) => {
			if ( elem.classList.contains( 'iportal-collapsed__title' )
					 && lastObj
				 ) {
				obj.headingLevel = lastObj.headingLevel +
					( lastElem.classList.contains( 'iportal-collapsed__title' ) ? 0 : 1 );
			}
			lastObj = obj;
			lastElem = elem;
			return obj;
		};
	}

	/**
	 * Checks for print media and moves the TOC if needed.
	 */
	fixPosition( print ) {
		if ( print ) {
			if ( this.oldParent ) {
				return;
			}
			var header = document.querySelector( '.language-and-breadcrumbs-header' );
			if ( this.toc ) {
				this.oldParent = this.toc.parentNode;
				this.oldNextSibling = this.toc.nextSibling;
				header.parentNode.insertBefore( this.toc, header.nextSibling );
			}
		} else {
			if ( this.oldParent ) {
				this.oldParent.insertBefore( this.toc, this.oldNextSibling );
				this.oldParent = null;
			}
		}
	}

	/**
	 * Adds 'js-toc-ignore' class to headings which should not show up in TOC.
	 */
	markHeadingsToIgnore() {
		for ( const heading of document.querySelectorAll( '.page-title' ) ) {
			heading.classList.add( 'js-toc-ignore' );
		}
		for ( const element of document.querySelectorAll(
			'.iportal-popup, .iportal-collapsed__content, .popups-appendix'
		) ) {
			for ( const heading of element.querySelectorAll( 'h1,h2,h3,h4,h5,h6' ) ) {
				heading.classList.add( 'js-toc-ignore' );
			}
		}
	};

	/**
	 * Add IDs to headings if not set.
	 */
	makeIDs( content ) {
		// Based on https://github.com/tscanlin/tocbot/blob/master/src/utils/make-ids.js
		var headings = content.querySelectorAll( 'h1, h2, h3, h4, h5, h6, h7, .iportal-collapsed__title' );
		var headingMap = {};

		Array.prototype.forEach.call( headings, function ( heading ) {
			var id = heading.id ? heading.id : heading.textContent.trim().toLowerCase()
					.split( ' ' ).join( '-' ).replace( /[\!\@\#\$\%\^\&\*\(\)\:]/ig, '' );
			headingMap[id] = ! isNaN( headingMap[id] ) ? ++headingMap[id] : 0;
			if ( headingMap[id] ) {
				heading.id = id + '-' + headingMap[id];
			} else {
				heading.id = id;
			}
		} );
	};
};
